import VueRouter from "vue-router";
import Vue from "vue";
import { staticPath } from "@/utils/baseUrl.js";
import Login from "./pages/login/login.vue";
import NotFound from "./pages/404/404.vue";
import agreementList from "./pages/agreement/agreementList.vue";
import agreementPages from "./pages/agreement/agreementPages.vue";
import agreeContent from "./pages/agreement/agreeContent.vue";

import { ksList } from "./ks-router.js";
import { ddList } from "./dd-router.js";
import { dyList } from "./dy-router.js";
import { wxList } from './wx-router.js'
import { sphList } from './sph-router.js'
import { xhsList } from './xhs-router.js'
import commonRouteList from "./common-router.js";
const noTokenPageList = []
let AddrouteListObj = {
  '/': dyList,
  '/dd/': ddList,
  '/ks/': ksList,
  '/wx/': wxList,
  '/sph/': sphList,
  '/xhs/': xhsList
}
let AddrouteList = { ...AddrouteListObj[staticPath], children: AddrouteListObj[staticPath].children.concat(commonRouteList)}
let whiteRouteList = [staticPath + 'dataIndex', staticPath + 'courseData',staticPath + 'gettingUserInformation'];
if (process.env.VUE_APP_GRALIC === "development") {
  whiteRouteList = [
    ...whiteRouteList,
    staticPath + 'specs',
    staticPath + 'material'
  ];
}
const originalReplace = VueRouter.prototype.replace;
import store from "./store/index.js";
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);
const createRouter = () =>
  new VueRouter({
    mode: "history",
    routes: [
      {
        path: staticPath + "notFound",
        name: "NotFound",
        component: NotFound,
      },
      // {
      //   path: staticPath,
      //   redirect:staticPath + 'index'
      // },
      {
        path: staticPath + "login",
        component: Login,
      },
	  {
	    path: staticPath + "agreementList",
	    name: "agreementList",
	    component: agreementList,
	  },
    {
	    path: staticPath + "agreeContent",
	    name: "agreeContent",
	    component: agreeContent,
	  },
	  {
	    path: staticPath + "agreementPages",
	    name: "agreementPages",
	    component: agreementPages
	  }
    ]
  })

function deepClone(obj) {
  let objClone = Array.isArray(obj) ? [] : {};
  if (obj && typeof obj === "object") {
    for (let key in obj) {
      if (obj[key] && typeof obj[key] === "object") {
        objClone[key] = deepClone(obj[key]);
      } else {
        objClone[key] = obj[key];
      }
    }
  }
  return objClone;
}
const router = createRouter();
let getMenuList = async () => {
  console.log('getMenuList-hhhhhhhh')
  let res = await store.dispatch("permission/getMenuList");
  const { menuList, menuTreeList } = res;
  const path = menuTreeList.length
    ? menuTreeList[0].children
      ? menuTreeList[0].children[0].route_name
      : menuTreeList[0].route_name
    : "";
  const copyAddrouteList = deepClone(AddrouteList);
  let AddrouteListChildren = copyAddrouteList.children;
  let arr = [];
  AddrouteListChildren.forEach((item, index) => {
    const obj = menuList.find((obj) => obj.route_name == item.meta.pathName);
    if (obj || whiteRouteList.includes(item.meta.pathName)) {
      if (obj) {
        item.meta.id = obj.id;
        item.meta.title = obj.name;
      }
      arr.push(item);
    }
  });
  copyAddrouteList.children = arr;
  let redirectList = [
    {
      path: staticPath,
      redirect: path,
    },
    {
      path: "*",
      redirect: staticPath + "notFound",
    },
  ];
  router.addRoutes([copyAddrouteList, ...redirectList]);
  return path;
};
// router.addRoutes([AddrouteList])
router.beforeEach((to, from, next) => {
  console.log("beforeEach-to:",to)
  let token = localStorage.getItem("token");
  if (token) {
    if (!store.state.permission.menuTreeList.length) {
      getMenuList().then((path) => {
        if (to.path === staticPath + "login") {
          //跳转到首页
          next({ path: staticPath });
        }
        next();
      });
    }
    next();
  } else {
    if (to.path !== staticPath + "login") {
      //跳转到登录页
      next({ path: staticPath + "login?redirect=" + to.path });
    } else {
      next();
    }
  }
});

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // 新路由实例matcer，赋值给旧路由实例的matcher，（相当于replaceRouter）
}
export default router;
